/*
 * Copyright (c) 2022-2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Component, OnInit, signal} from '@angular/core';
import {environment} from '../../../environments/environment';
import {AppInfoService} from '../../service/app-info.service';
import {UserService} from '../../shared/user.service';
import {EsciMessageService} from '../../shared/esci-message.service';

@Component({
    selector: 'gm-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.less'],
    standalone: false
})
export class FooterComponent implements OnInit {

  public currentYear: number;
  private readonly apiVersionSignal = signal('');
  uiVersion = environment.uiVersion ?? '';
  environmentName = environment.environmentName;

  constructor(protected userService: UserService, private appInfoService: AppInfoService,
              private messageService: EsciMessageService) {
  }

  get apiVersion(): string {
    return this.apiVersionSignal();
  }

  set apiVersion(value: string) {
    this.apiVersionSignal.set(value ?? '');
  }

  ngOnInit() {
    const date = new Date();
    this.currentYear = date.getFullYear();
    this.loadApiVersion();
  }

  loadApiVersion() {
    this.appInfoService.getApiVersion().subscribe({
        next: (response) => {
            this.apiVersion = response;
        },
        error: () => {
            this.apiVersion = 'Unknown';
            this.messageService.processError('Unable to connect to eSCI. Please try again later.');
        }
    });
  }
}
